import React from "react";
import styled from "styled-components";

const StyledMenu = styled.nav`
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  background: linear-gradient(180deg,rgba(255, 255, 255, 1) 60%, rgba(90, 90, 90, 0) 100%);

  transform: ${({ open }) => (open ? "translateX(0)" : "translateX(100%)")};

  display: ${({ open }) => (open ?  "true" : "none")};
  
  height: 100vh;
  text-align: center;
  padding: 2rem;
  margin-top:80px;
  position: absolute;
  top: 0;
  right: 0%;
  transition: transform 0.3s ease-in-out;
  z-index: 9;
  height:75vh;
  
  @media (max-width: 576px) {
    width: 100%;
  }

  a {
    font-size: 1.5rem;
    text-transform: uppercase;
    padding: 1rem 0;
    font-weight: bold;
    letter-spacing: 0.3rem;
    color: #3f3f3f;
    text-decoration: none;
    transition: color 0.3s linear;

    @media (max-width: 576px) {
      font-size: 1.5rem;
      text-align: center;
    }

    &:hover {
      color: rgb(54, 141, 255);
    }
  }
`;

const Menu = ({ open, setOpen }) => {
  return (
    <StyledMenu open={open} className="mySMenu">  
      <a href="#trattamenti" onClick={() => setOpen(!open)}> 
          trattamenti
      </a> 
      <a href="#foto" onClick={() => setOpen(!open)}> 
          Foto
      </a>
      <a href="#Contatti" onClick={() => setOpen(!open)}> 
          Contatti
      </a> 
    </StyledMenu>
  );
};

export default Menu;
